module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.arquivo) ? _c('div', {
    staticClass: "download",
    style: ('max-width:' + (_vm.fullWidth ? '100%' : this.window.width * 0.5 + ' px') + ' !important')
  }, [_c('el-popover', {
    attrs: {
      "placement": "top",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b', [_vm._v("Arquivo:")]), _vm._v(" (" + _vm._s(_vm.arquivo.id) + ") " + _vm._s(_vm.arquivo.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b', [_vm._v("Tamanho:")]), _vm._v(" " + _vm._s(_vm.toMb(_vm.arquivo.size)) + " \n        "), (_vm.arquivo.width && _vm.arquivo.height) ? _c('span', [_vm._v("\n          (" + _vm._s(_vm.arquivo.width) + "x" + _vm._s(_vm.arquivo.height) + ")\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.arquivo.id && _vm.arquivo.type && _vm.arquivo.type.indexOf('image') != -1) ? _c('div', {
    staticClass: "col-md-12 text-center pt-2 pb-2"
  }, [_c('el-image', {
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "title": "Clique para visualizar a imagem",
      "src": _vm.displayFile(_vm.arquivo),
      "fit": "scale-down",
      "preview-src-list": [_vm.displayFile(_vm.arquivo)]
    }
  }, [_c('div', {
    staticClass: "image-slot",
    attrs: {
      "slot": "error"
    },
    slot: "error"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline fa-2x"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.arquivo.id) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "value": "Baixar Arquivo",
      "icon": "fa fa-download"
    },
    on: {
      "click": function($event) {
        return _vm.downloadFile(_vm.arquivo)
      }
    }
  }), _vm._v(" "), _c('ed-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "value": "Deletar Arquivo",
      "icon": "fa fa-times",
      "loading": _vm.loadingDelete
    },
    on: {
      "click": function($event) {
        return _vm.deleteFile(_vm.arquivo)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.arquivo.name) + " (" + _vm._s(_vm.toMb(_vm.arquivo.size)) + ")")])])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b27771b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/download.vue
// module id = 1548
// module chunks = 45